var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signedIn)?_c('el-button',{on:{"click":_vm.doSignOut}},[_vm._v("Sign Out")]):_c('el-button',{on:{"click":_vm.goAuth}},[_vm._v("Sign In")])}
var staticRenderFns = []

export { render, staticRenderFns }